import { componentsReducer } from "../../redux/root.reducer";
import { SearchbarActions } from "./actions";

export function searchbarReducerFactory(rootProp, initialState) {
    return function searchbarReducer(state = initialState, action) {
        state = componentsReducer(rootProp, state, action);
        switch (action.type) {
            case `${rootProp}::${SearchbarActions.SEARCH_TEXT_CHANGED}`:
                return state.setIn([action.stateProp, "value"], action.payload);
            default:
                return state;
        }
    };
}
